import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { registrationService } from '../services/registrationService';

const { FiCheck, FiLoader, FiAlertCircle, FiMessageCircle, FiShield } = FiIcons;

export default function SuccessPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying');
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    const pendingId = localStorage.getItem('pending_reg_id');
    console.log("SuccessPage: Detected pending ID:", pendingId);
    
    if (pendingId) {
      verifyAndSync(pendingId);
    } else {
      console.warn("SuccessPage: No pending ID found in localStorage");
      setStatus('error');
    }
  }, []);

  const verifyAndSync = async (id) => {
    try {
      console.log(`SuccessPage: Attempting to update status for ${id}...`);
      const success = await registrationService.updateStatus(id, 'Paid');
      
      if (success) {
        console.log("SuccessPage: Status updated to Paid successfully.");
        setStatus('success');
        localStorage.removeItem('pending_reg_id');
      } else {
        // ลองใหม่ในกรณีที่ Google Sheet ยังไม่สะท้อนข้อมูลทันที
        if (retryCount < 3) {
          console.log(`SuccessPage: Update failed, retrying... (${retryCount + 1})`);
          setTimeout(() => {
            setRetryCount(prev => prev + 1);
            verifyAndSync(id);
          }, 3000);
        } else {
          setStatus('error');
        }
      }
    } catch (error) {
      console.error('SuccessPage: Error during updateStatus:', error);
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6 pt-20">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-xl w-full bg-white border-2 border-zinc-200 p-8 md:p-12 shadow-[20px_20px_0px_0px_rgba(0,0,0,0.05)] text-center relative overflow-hidden">
        <div className="absolute top-0 right-0 opacity-[0.03] -mr-16 -mt-16">
          <SafeIcon icon={FiShield} className="w-64 h-64 text-zinc-900" />
        </div>

        {status === 'verifying' && (
          <div className="space-y-6 relative z-10">
            <div className="w-20 h-20 bg-zinc-900 rounded-full flex items-center justify-center mx-auto shadow-xl">
              <SafeIcon icon={FiLoader} className="w-10 h-10 text-white animate-spin" />
            </div>
            <h2 className="text-2xl font-black uppercase tracking-tighter text-zinc-900">กำลังยืนยันการชำระเงิน</h2>
            <p className="text-zinc-500 font-medium italic">กรุณารอสักครู่ ระบบกำลังนำชื่อของคุณเข้าสู่รายชื่อผู้เรียน...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-8 relative z-10 text-left">
            <div className="w-20 h-20 bg-green-500 rounded-full flex items-center justify-center shadow-xl shadow-green-200">
              <SafeIcon icon={FiCheck} className="w-10 h-10 text-white" />
            </div>
            <div>
              <h2 className="text-4xl font-black text-zinc-900 mb-2 tracking-tighter uppercase">ชำระเงินสำเร็จ!</h2>
              <p className="text-xl font-bold text-brand-red italic">ยินดีต้อนรับสู่ BAZI FINANCIAL รุ่นที่ 1</p>
            </div>
            <div className="space-y-4 border-l-4 border-zinc-900 pl-6 py-2">
              <p className="text-zinc-600 font-medium leading-relaxed">
                ระบบอัปเดตสถานะของคุณเป็น <span className="font-black text-zinc-900">Paid</span> และสำเนาข้อมูลไปยังฐานข้อมูลผู้เรียนเรียบร้อยแล้ว
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button onClick={() => window.open('https://line.me/ti/p/@fengshuix', '_blank')} className="flex-grow py-5 bg-[#06C755] text-white font-black uppercase tracking-widest text-xs flex items-center justify-center gap-3 hover:brightness-110 transition-all shadow-lg">
                <SafeIcon icon={FiMessageCircle} className="w-5 h-5" /> แจ้งแอดมินใน LINE
              </button>
              <button onClick={() => navigate('/')} className="px-8 py-5 bg-zinc-900 text-white font-black uppercase tracking-widest text-xs hover:bg-brand-red transition-all">กลับหน้าหลัก</button>
            </div>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-6 relative z-10">
            <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto border-2 border-red-500">
              <SafeIcon icon={FiAlertCircle} className="w-10 h-10 text-red-500" />
            </div>
            <h2 className="text-2xl font-black uppercase tracking-tighter">ไม่พบข้อมูลอัปเดตอัตโนมัติ</h2>
            <p className="text-zinc-500 font-medium">หากคุณชำระเงินสำเร็จแล้ว ไม่ต้องกังวลครับ กรุณาแจ้งชื่อให้แอดมินทาง LINE เพื่อตรวจสอบและเปิดสิทธิ์ให้ทันที</p>
            <button onClick={() => window.open('https://line.me/ti/p/@fengshuix', '_blank')} className="w-full py-5 bg-[#06C755] text-white font-black uppercase tracking-widest text-sm flex items-center justify-center gap-3">
              <SafeIcon icon={FiMessageCircle} className="w-5 h-5" /> ติดต่อแอดมินด่วน
            </button>
          </div>
        )}
      </motion.div>
    </div>
  );
}